// extracted by mini-css-extract-plugin
export default {"section":"HowWeWork_section__+w+2w","intro":"HowWeWork_intro__wFJW-","steps":"HowWeWork_steps__ZOzvJ","step":"HowWeWork_step__IjSK8","number":"HowWeWork_number__wZFy9"};